import messages from './print-modal-translations';

export default {
    name: 'print-modal',
    i18n: {
        messages,
    },
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        imageUrl: {
            type: String,
        },
        name: {
            type: String,
        },
        author: {
            type: String,
        },
    },
    methods: {
        dismiss: function () {
            this.$emit('closePrintModal');
        },
        printTemplate: function () {
            this.$emit('closePrintModal');

            var styles = `
                <style>
                    @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');

                    .print-preview {
                        font-family: 'Source Sans Pro', sans-serif;
                        width: 100%;
                        margin: 16px auto;
                        text-align: center;
                    }

                    .print-preview .print-preview-heading img {
                        height: 24px;
                        width: auto;
                    }
                    
                    .print-preview .print-preview-body img {
                        width: 100%;
                        height: auto;
                    }

                    .print-preview textarea {
                        display: block;
                        box-sizing: border-box;
                        width: 100%;
                        height: 180px;
                        background: none;
                        margin-top: 48px;
                        border: none;
                        border-top: 1px solid #eee;
                        border-bottom: 1px solid #eee;
                    }

                    .print-preview .print-preview-footer {
                        padding-top: 48px;
                    }
                    
                    .print-preview .print-preview-footer img {
                        height: 42px;
                        width: auto;
                    }

                    .print-preview .print-preview-footer2 img {
                        height: 80px;
                        width: auto;
                    }
                </style>
            `;

            var template = document.getElementById('printable-document');
            var notes = document.getElementById('printable-document-notes');
            var notesContent = document.createElement('p');
            if (notes!==null) notesContent.innerHTML = notes.value;
            notes.parentElement.appendChild(notesContent);
            notes.parentElement.removeChild(notes);

            var printableWindow = window.open('', '_blank', 'height=600,width=1024');
            printableWindow.document.write('<html><head><title>' + this.name + '</title>');
            printableWindow.document.write(styles);
            printableWindow.document.write('</head><body >');          
            printableWindow.document.write(template.outerHTML);
            printableWindow.document.write('</body></html>');
            printableWindow.document.close();
            printableWindow.focus();
            printableWindow.onload = function () {
                printableWindow.print();
            };
        },
        isAuthorEuroregio:function(){
            if (this.author.indexOf("euroregio")>-1) return true;
            else return false;
        }
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/print-modal/print-modal.js